// extracted by mini-css-extract-plugin
export var callCard = "_mp-0";
export var callMessageButton = "_mp-1";
export var helpIcon = "_mp-3";
export var helpIconContainer = "_mp-4";
export var verticalDivider = "_mp-2";